/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 9999eb1d882990f19e352fba26b6c3f62977c8a7
 */

export type ProductFormat = typeof ProductFormat[keyof typeof ProductFormat];


export const ProductFormat = {
  epub: 'epub',
  mobi: 'mobi',
  pdf: 'pdf',
  zip: 'zip',
  lpf: 'lpf',
} as const;
